export default __webpack_public_path__ + "static/media/DOM-AUG-2024.34b90066.png";